/**
 * Translation Loader Interface
 * 
 * This file exports the translation loader that will be used.
 * The actual implementation is swapped via angular.json fileReplacements:
 * - Browser build: uses translate-loader.browser.ts (HTTP-based)
 * - Server build: uses translate-loader.server.ts (filesystem-based)
 * 
 * This file is the "browser" version by default.
 */

import { HttpClient } from "@angular/common/http";
import { TranslateLoader } from "@ngx-translate/core";
import { NgxTranslateModuleLoader } from "../modules/ngxTranslateModule/ngx-translate-module.loader";

export const startUpTime = +new Date();

export interface TranslateLoaderConfig {
  basePath: string;
  modules: string[];
}

/**
 * Creates the appropriate translation loader.
 * Browser version - uses HTTP to fetch translations.
 */
export function createTranslateLoader(
  http: HttpClient,
  config: TranslateLoaderConfig
): TranslateLoader {
  const baseTranslateUrl = config.basePath;
  
  const options: any = {
    disableNamespace: true,
    lowercaseNamespace: true,
    version: startUpTime,
    modules: [
      { baseTranslateUrl },
    ]
  };
  
  config.modules.forEach((moduleName: string) => {
    options.modules.push({ baseTranslateUrl, moduleName });
  });
  
  return new NgxTranslateModuleLoader(http, options);
}

/**
 * Flag to indicate if this is server-side rendering.
 * Browser version always returns false.
 */
export const IS_SERVER_PLATFORM = false;
